import Icon from '@/components/ui/AppIcon';

interface TimelineStep {
  id: string;
  title: string;
  description: string;
  icon: 'UserIcon' | 'MapIcon' | 'CheckCircleIcon';
  time: string;
}

const steps: TimelineStep[] = [
  {
    id: 'timeline_assign',
    title: 'Scooter Located',
    description: 'We\'ll show you the nearest available scooter',
    icon: 'UserIcon',
    time: '1 min',
  },
  {
    id: 'timeline_track',
    title: 'Unlock & Ride',
    description: 'Scan QR code to unlock and start your ride',
    icon: 'MapIcon',
    time: '2 min',
  },
  {
    id: 'timeline_complete',
    title: 'Park & Pay',
    description: 'Park in designated zone and payment is automatic',
    icon: 'CheckCircleIcon',
    time: 'On arrival',
  },
]

export default function ExpectationTimeline() {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-muted/30">
      <div className="max-w-4xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-primary mb-3">
            What Happens Next?
          </h2>
          <p className="text-muted-foreground font-body">
            Here's what you can expect after booking your scooter
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 bg-gradient-to-r from-secondary via-accent to-success" />

          <div className="grid md:grid-cols-3 gap-8 relative">
            {steps.map((step, index) => (
              <div key={step.id} className="relative text-center">
                {/* Icon Circle */}
                <div className="relative inline-flex items-center justify-center w-24 h-24 rounded-full bg-white shadow-lg border-4 border-white mb-6 z-10">
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-secondary to-accent flex items-center justify-center">
                    <Icon
                      name={step.icon}
                      variant="solid"
                      size={32}
                      className="text-white"
                    />
                  </div>
                </div>

                {/* Time Badge */}
                <div className="inline-block px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-body font-bold mb-3">
                  {step.time}
                </div>

                {/* Content */}
                <h3 className="text-xl font-display font-bold text-primary mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-muted-foreground font-body">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Info Card */}
        <div className="mt-12 p-6 rounded-2xl bg-success/5 border border-success/20">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
              <Icon name="InformationCircleIcon" size={24} className="text-success" />
            </div>
            <div className="flex-1">
              <h4 className="font-display font-bold text-primary mb-2">
                Need to End Early?
              </h4>
              <p className="text-sm text-foreground/70 font-body">
                You can end your ride anytime by parking in a designated zone and tapping "End Ride" in the app.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}